<template>
    <div class="container-fluid">
        <route-header>
            <h3>{{ resource.name }}</h3>
            <nav-secondary-customer :customer="customer" />
        </route-header>
        <div class="row">
            <div class="col">
                <schedule v-if="customer" :customer="customer" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CustomerSchedule',
  props: ['customer'],
  computed: {
    ...mapState({
      resource: state => state.customer.data
    })
  }
}
</script>
